import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { chesterConfig } from "./data";

export default function ChesterPage() {
  return <CityPageTemplate config={chesterConfig} />;
}